module.exports = __webpack_public_path__ + "img/fire-robber.ac15379c.png";